import {
  FLOOR_ACTIONS_OVERLAY,
  PRODUCT_POSITION_ACTIONS_OVERLAY,
  PROJECT_ACTIONS_OVERLAY,
  ROOM_ACTIONS_OVERLAY
} from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { Action } from "shared/types/Action"
import {
  isProjectFloor,
  isProjectProductPosition,
  isProjectRoom
} from "shared/types/Project"

import { useOpenProjectChildren } from "../sidebar/hooks/useOpenProjectChildren"

export function useProjectPageActionsButton(
  projectID: string,
  options?: { additionalActions?: Action[] }
) {
  const selectedChildren = useOpenProjectChildren({ projectID })
  const { openOverlay: openProjectActionsOverlay } = useOverlay(
    PROJECT_ACTIONS_OVERLAY
  )
  const { openOverlay: openRoomActionsOverlay } =
    useOverlay(ROOM_ACTIONS_OVERLAY)
  const { openOverlay: openFloorActionsOverlay } = useOverlay(
    FLOOR_ACTIONS_OVERLAY
  )
  const { openOverlay: openProductPositionActionsOverlay } = useOverlay(
    PRODUCT_POSITION_ACTIONS_OVERLAY
  )

  return useEvent(() => {
    if (
      !selectedChildren ||
      selectedChildren.length === 0 ||
      selectedChildren.length > 1
    ) {
      openProjectActionsOverlay({
        projectID,
        additionalActions: options?.additionalActions
      })
    }
    if (isProjectFloor(selectedChildren[0])) {
      openFloorActionsOverlay({
        projectID,
        floorID: selectedChildren[0].id
      })
    }
    if (isProjectRoom(selectedChildren[0])) {
      openRoomActionsOverlay({
        projectID,
        roomID: selectedChildren[0].id
      })
    }
    if (isProjectProductPosition(selectedChildren[0])) {
      openProductPositionActionsOverlay({
        projectID,
        productPositionID: selectedChildren[0]
      })
    }
  })
}
